import React, { createContext, useContext, useState, useEffect, useRef } from "react";
import { useJwt } from "./JWTContext"; // Importa tu contexto JWT
import { getGlobalValues } from "../api/globalValues";

// Crear el contexto
const GlobalValuesContext = createContext();

// Proveedor del contexto
export const GlobalValuesProvider = ({ children }) => {
  const { isLoggedIn, user } = useJwt(); // Accede al estado de autenticación
  const globalVal =  useRef();
  // const [globalValues, setGlobalValues] = useState({
  //   tiposComprobantes: [],
  //   // Agrega aquí otros valores globales iniciales si los necesitas
  // });
  const [selectedSucursal, setSelectedSucursal] = useState({
    id_sucursal: 1,
    sucursal:''
  });

  useEffect(() => {
    // Cargar los datos iniciales
    const loadValues = async () => {
      try {
        const global = await getGlobalValues();
        globalVal.current = global;
        const selectedSuc = global.sucursales.find((item) => item.id_sucursal === user.id_sucursal)

        localStorage.setItem("globalValues", JSON.stringify(global)); // Guardar en localStorage
        
        setSelectedSucursal({
          id_sucursal: user.id_sucursal,
          sucursal: selectedSuc? selectedSuc.sucursal : 'Todas'
        });
        
      } catch (error) {
        console.error("Error al cargar los valores globales:", error);
      }
    };

    if (isLoggedIn) {
      loadValues();
    }
    // eslint-disable-next-line
  }, [isLoggedIn]);

  return (
    <GlobalValuesContext.Provider value={{globalVal, selectedSucursal, setSelectedSucursal}}>
      {children}
    </GlobalValuesContext.Provider>
  );
};

// Hook personalizado para usar el contexto
export const useGlobalValues = () => {
  return useContext(GlobalValuesContext);
};
